import { useState } from 'react';

const HomePage = () => {
  const [activeTab, setActiveTab] = useState('數學');

  const courses = {
    數學: [
      { name: '小一數學基礎', level: '小一', description: '透過遊戲學習數字概念與基礎運算', price: '' },
      { name: '小二數學進階', level: '小二', description: '加減乘除遊戲化學習', price: '' },
      { name: '小三數學應用', level: '小三', description: '生活數學遊戲實作', price: '' },
      { name: '小四數學邏輯', level: '小四', description: '邏輯思維遊戲訓練', price: '' },
      { name: '小五數學挑戰', level: '小五', description: '進階數學概念遊戲', price: '' },
      { name: '小六數學精通', level: '小六', description: '升學準備遊戲化複習', price: '' }
    ],
    奧數: [
      { name: '奧數啟蒙班', level: '小一-小二', description: '數學思維啟發遊戲', price: '' },
      { name: '奧數基礎班', level: '小三-小四', description: '邏輯推理遊戲訓練', price: '' },
      { name: '奧數進階班', level: '小五-小六', description: '競賽題型遊戲化練習', price: '' }
    ],
    卓越杯: [
      { name: '卓越杯預備班', level: '小三-小四', description: '競賽技巧遊戲化訓練', price: '' },
      { name: '卓越杯衝刺班', level: '小五-小六', description: '歷屆試題遊戲解析', price: '' }
    ],
    超越杯: [
      { name: '超越杯預備班', level: '小三-小四', description: '競賽技巧遊戲化訓練', price: '' },
      { name: '超越杯衝刺班', level: '小五-小六', description: '歷屆試題遊戲解析', price: '' }
    ],
    中文中檢: [
      { name: '中檢初級班', level: '小一-小二', description: '基礎中文遊戲學習', price: '' },
      { name: '中檢中級班', level: '小三-小四', description: '中文能力遊戲提升', price: '' },
      { name: '中檢高級班', level: '小五-小六', description: '中文檢定遊戲準備', price: '' }
    ],
    英文英檢: [
      { name: '劍橋 Starters', level: '小一-小二', description: '劍橋兒童英語認證入門級', price: '' },
      { name: '劍橋 Movers', level: '小二-小三', description: '劍橋兒童英語認證基礎級', price: '' },
      { name: '劍橋 Flyers', level: '小三-小四', description: '劍橋兒童英語認證進階級', price: '' },
      { name: '劍橋 KET', level: '小四-小五', description: '劍橋英語基礎認證', price: '' },
      { name: '劍橋 PET', level: '小五-小六', description: '劍橋英語初級認證', price: '' },
      { name: '全民英檢初級初試', level: '小四-小六', description: '全民英檢初級聽力閱讀測驗', price: '' },
      { name: '全民英檢初級複試', level: '小四-小六', description: '全民英檢初級口說寫作測驗', price: '' },
      { name: '全民英檢中級初試', level: '小五-小六', description: '全民英檢中級聽力閱讀測驗', price: '' },
      { name: '全民英檢中級複試', level: '小五-小六', description: '全民英檢中級口說寫作測驗', price: '' }
    ],
    考私中: [
      { name: '私中預備班', level: '小五', description: '私中入學考試準備', price: '' },
      { name: '私中衝刺班', level: '小六', description: '私中考試全科衝刺', price: '' },
      { name: '私中模擬考班', level: '小六', description: '模擬考試與解題訓練', price: '' }
    ],
    大班升小一: [
      { name: '注音符號班', level: '大班', description: '注音符號認讀與拼音遊戲', price: '' },
      { name: '數字概念班', level: '大班', description: '基礎數字認知與運算準備', price: '' },
      { name: '小一先修班', level: '大班', description: '小學課程銜接準備', price: '' },
      { name: '學習習慣養成班', level: '大班', description: '培養良好學習態度與專注力', price: '' }
    ],
    月考總複習: [
      { name: '月考數學複習', level: '小一-小六', description: '月考前數學重點複習', price: '150/堂' },
      { name: '月考國文複習', level: '小一-小六', description: '月考前國文重點複習', price: '150/堂' },
      { name: '月考英文複習', level: '小一-小六', description: '月考前英文重點複習', price: '150/堂' },
      { name: '月考自然複習', level: '小三-小六', description: '月考前自然重點複習', price: '150/堂' },
      { name: '月考社會複習', level: '小三-小六', description: '月考前社會重點複習', price: '150/堂' }
    ]
  };

  const features = [
    {
      icon: 'ri-gamepad-line',
      title: '遊戲化教學',
      description: '將學習內容融入有趣的遊戲中，讓孩子在玩樂中自然吸收知識'
    },
    {
      icon: 'ri-trophy-line',
      title: '競賽培訓',
      description: '專業的奧數和卓越杯競賽培訓，提升孩子的數學思維能力'
    },
    {
      icon: 'ri-book-open-line',
      title: '多元課程',
      description: '涵蓋數學、中文、英文等多個學科，滿足不同學習需求'
    },
    {
      icon: 'ri-user-star-line',
      title: '個人化學習',
      description: '根據每個孩子的學習進度，提供客製化的學習方案'
    }
  ];

  const testimonials = [
    // 北部家長
    {
      name: '王媽媽',
      child: '小明 (小三)',
      location: '台北市',
      content: '自從參加CM探索的數學課程後，小明對數學的興趣大增，成績也進步了很多！',
      rating: 5
    },
    {
      name: '李爸爸',
      child: '小華 (小五)',
      location: '新北市',
      content: '遊戲化的教學方式真的很棒，孩子不再害怕學習，反而很期待每次上課。',
      rating: 5
    },
    {
      name: '陳媽媽',
      child: '小美 (小四)',
      location: '桃園市',
      content: '老師很用心，課程設計有趣，小美的英文能力提升了不少。',
      rating: 5
    },
    {
      name: '林爸爸',
      child: '小傑 (小六)',
      location: '基隆市',
      content: '準備私中考試壓力很大，但CM探索的課程讓孩子在輕鬆的氛圍中學習，最後順利考上理想學校！',
      rating: 5
    },
    {
      name: '張媽媽',
      child: '小芳 (小二)',
      location: '新竹市',
      content: '孩子從大班就開始上課，現在小二了，學習習慣養成得很好，成績一直保持前三名。',
      rating: 5
    },
    // 中部家長
    {
      name: '黃媽媽',
      child: '小宇 (小三)',
      location: '台中市',
      content: '奧數課程讓小宇的邏輯思維能力大幅提升，參加卓越杯還得了獎！',
      rating: 5
    },
    {
      name: '吳爸爸',
      child: '小婷 (小五)',
      location: '彰化縣',
      content: '線上家教很方便，不用接送孩子，老師一對一指導效果很好。',
      rating: 5
    },
    {
      name: '劉媽媽',
      child: '小安 (小四)',
      location: '南投縣',
      content: '中檢課程設計得很完整，小安通過了中級檢定，對中文更有信心了。',
      rating: 5
    },
    {
      name: '周爸爸',
      child: '小強 (小六)',
      location: '雲林縣',
      content: '月考總複習課程很實用，每次考前複習都能抓到重點，成績進步明顯。',
      rating: 5
    },
    {
      name: '鄭媽媽',
      child: '小玲 (小一)',
      location: '苗栗縣',
      content: '遊戲化教學讓孩子愛上學習，每天都主動要求上課，學習效果超乎預期。',
      rating: 5
    }
  ];

  const handleTrialSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      data.append(key, value.toString());
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d4dii2qahcjh6clrrjo0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });

      if (response.ok) {
        alert('試聽申請已送出，我們將盡快與您聯繫！');
        (e.target as HTMLFormElement).reset();
      } else {
        alert('送出失敗，請稍後再試。');
      }
    } catch (error) {
      alert('送出失敗，請稍後再試。');
    }
  };

  const handleConsultSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      data.append(key, value.toString());
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/submit/course-consultation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });

      if (response.ok) {
        alert('諮詢申請已送出，我們將盡快與您聯繫！');
        (e.target as HTMLFormElement).reset();
      } else {
        alert('送出失敗，請稍後再試。');
      }
    } catch (error) {
      alert('送出失敗，請稍後再試。');
    }
  };

  const handleMembershipSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      data.append(key, value.toString());
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d4difm2els5gugpjmoj0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });

      if (response.ok) {
        alert('會員購買申請已送出，我們將盡快與您聯繫確認訂單！');
        (e.target as HTMLFormElement).reset();
      } else {
        alert('送出失敗，請稍後再試。');
      }
    } catch (error) {
      alert('送出失敗，請稍後再試。');
    }
  };

  const handleTutoringSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData.entries());
    
    // 驗證必填欄位
    const requiredFields = ['student_name', 'student_grade', 'parent_name', 'phone', 'course_plan', 'subject'];
    const missingFields = requiredFields.filter(field => !data[field]);
    
    if (missingFields.length > 0) {
      alert('請填寫所有必填欄位');
      return;
    }
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4cu0nm820p5j87gahi0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data as Record<string, string>).toString()
      });
      
      if (response.ok) {
        alert('預約申請已提交成功！我們將盡快與您聯繫安排課程。');
        (e.target as HTMLFormElement).reset();
      } else {
        throw new Error('提交失敗');
      }
    } catch (error) {
      alert('提交失敗，請稍後再試');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-graduation-cap-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-bold text-gray-900" style={{fontFamily: '"Pacifico", serif'}}>CM探索教育科技</h1>
                <p className="text-xs md:text-sm text-gray-600">遊戲化學習專家</p>
              </div>
            </div>
            <nav className="hidden lg:flex space-x-8">
              <a href="#courses" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">課程介紹</a>
              <a href="#features" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">教學特色</a>
              <a href="#testimonials" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">家長好評</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">聯絡我們</a>
            </nav>
            <button 
              onClick={() => document.querySelector('#trial-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 md:px-6 py-2 rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              免費試聽
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-12 md:py-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/ba3f8b63dd6fc55a276005797fb2a430.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-purple-900/60"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="text-white">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 leading-tight">
                讓學習變成
                <span className="text-yellow-300">遊戲</span>
                <br />讓孩子愛上學習
              </h2>
              <p className="text-lg md:text-xl mb-6 md:mb-8 text-blue-100">
                CM探索教育科技專注於遊戲化教學，提供小一到小六的數學、奧數、中檢、英文課程。
                透過創新的教學方式，讓孩子在玩樂中掌握知識，建立學習自信。
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={() => document.querySelector('#trial-form')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-yellow-400 text-gray-900 px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:bg-yellow-300 transition-all whitespace-nowrap cursor-pointer"
                >
                  立即免費試聽
                </button>
                <button 
                  onClick={() => document.querySelector('#courses')?.scrollIntoView({ behavior: 'smooth' })}
                  className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
                >
                  瀏覽課程
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Special Offer Section */}
      <section className="py-12 md:py-16 bg-gradient-to-r from-orange-400 to-red-500 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-block bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-bold mb-4 animate-pulse">
              🔥 限時優惠活動
            </div>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
              超值年度會員方案
            </h3>
            <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto">
              {/* 基礎方案 */}
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-2xl">
                <div className="text-center mb-4 md:mb-6">
                  <h4 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                    基礎方案
                  </h4>
                  <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-4">
                    NT$ 6,000 / 年
                  </div>
                </div>
                <div className="space-y-3 md:space-y-4 text-base md:text-lg mb-4 md:mb-6">
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">免費贈送學習平板一台</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">可任選兩個年級課程</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">數學、國文、社會、英文、自然課程</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">24小時隨時學習</span>
                  </div>
                </div>
                <button 
                  onClick={() => document.querySelector('#membership-form')?.scrollIntoView({ behavior: 'smooth' })}
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                >
                  選擇基礎方案
                </button>
              </div>

              {/* 完整方案 */}
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-2xl border-4 border-yellow-400 relative">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-yellow-400 text-black px-4 md:px-6 py-2 rounded-full text-sm font-bold">
                    🏆 推薦方案
                  </div>
                </div>
                <div className="text-center mb-4 md:mb-6">
                  <h4 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                    完整方案
                  </h4>
                  <div className="text-3xl md:text-4xl font-bold text-orange-600 mb-4">
                    NT$ 9,000 / 年
                  </div>
                </div>
                <div className="space-y-3 md:space-y-4 text-base md:text-lg mb-4 md:mb-6">
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">免費贈送學習平板一台</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">可任選兩個年級課程</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">數學、奧數、卓越杯、超越杯</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">國文、中檢、英文、劍橋檢定、全民英檢</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">自然、社會課程</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-lg md:text-xl mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">24小時隨時學習</span>
                  </div>
                </div>
                <button 
                  onClick={() => document.querySelector('#membership-form')?.scrollIntoView({ behavior: 'smooth' })}
                  className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                >
                  選擇完整方案
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Online Tutoring Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-purple-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">線上課程家教</h3>
            <p className="text-lg md:text-xl text-gray-600">一對一專業家教指導，客製化學習方案</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {/* 10堂課程 */}
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 text-center hover:shadow-xl transition-all">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-purple-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-white text-xl md:text-2xl"></i>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">體驗方案</h4>
              <div className="text-2xl md:text-3xl font-bold text-purple-600 mb-4">NT$ 7,000</div>
              <p className="text-gray-600 mb-4 md:mb-6">10堂一對一家教課程</p>
              <ul className="text-left space-y-2 mb-4 md:mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">專業師資一對一教學</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">客製化學習計畫</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">課後作業指導</span>
                </li>
              </ul>
              <button 
                onClick={() => document.querySelector('#tutoring-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full bg-gradient-to-r from-purple-500 to-blue-600 text-white py-3 rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                立即預約
              </button>
            </div>

            {/* 20堂課程 */}
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 text-center hover:shadow-xl transition-all border-2 border-blue-200">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-blue-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-white text-xl md:text-2xl"></i>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">進階方案</h4>
              <div className="text-2xl md:text-3xl font-bold text-blue-600 mb-4">NT$ 12,000</div>
              <p className="text-gray-600 mb-4 md:mb-6">20堂一對一家教課程</p>
              <ul className="text-left space-y-2 mb-4 md:mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">專業師資一對一教學</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">深度學習追蹤</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">定期學習報告</span>
                </li>
              </ul>
              <button 
                onClick={() => document.querySelector('#tutoring-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full bg-gradient-to-r from-blue-500 to-cyan-600 text-white py-3 rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                立即預約
              </button>
            </div>

            {/* 30堂課程 */}
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 text-center hover:shadow-xl transition-all border-2 border-green-200">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-medal-line text-white text-xl md:text-2xl"></i>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">完整方案</h4>
              <div className="text-2xl md:text-3xl font-bold text-green-600 mb-4">NT$ 15,000</div>
              <p className="text-gray-600 mb-4 md:mb-6">30堂一對一家教課程</p>
              <ul className="text-left space-y-2 mb-4 md:mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">專業師資一對一教學</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">全方位學習支援</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">家長定期溝通</span>
                </li>
              </ul>
              <button 
                onClick={() => document.querySelector('#tutoring-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                立即預約
              </button>
            </div>

            {/* 月考總複習 */}
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 text-center hover:shadow-xl transition-all border-2 border-orange-200">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-white text-xl md:text-2xl"></i>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">月考總複習</h4>
              <div className="text-2xl md:text-3xl font-bold text-orange-600 mb-4">NT$ 150<span className="text-lg">/堂</span></div>
              <p className="text-gray-600 mb-4 md:mb-6">公立國小月考前總複習</p>
              <ul className="text-left space-y-2 mb-4 md:mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">考前重點整理</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">模擬試題練習</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2 flex-shrink-0"></i>
                  <span className="text-sm">弱點加強輔導</span>
                </li>
              </ul>
              <button 
                onClick={() => document.querySelector('#tutoring-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white py-3 rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                立即預約
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">為什麼選擇CM探索教育？</h3>
            <p className="text-lg md:text-xl text-gray-600">創新的遊戲化教學方式，讓學習更有趣更有效</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center p-4 md:p-6 rounded-xl bg-gradient-to-br from-blue-50 to-purple-50 hover:shadow-lg transition-all">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${feature.icon} text-white text-xl md:text-2xl`}></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3">{feature.title}</h4>
                <p className="text-gray-600 text-sm md:text-base">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section id="courses" className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">精彩課程內容</h3>
            <p className="text-lg md:text-xl text-gray-600">涵蓋小一到小六，全方位的學習方案</p>
          </div>
          
          {/* Course Tabs */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8 md:mb-12">
            {Object.keys(courses).map((category) => (
              <button
                key={category}
                onClick={() => setActiveTab(category)}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer text-sm md:text-base ${
                  activeTab === category
                    ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}課程
              </button>
            ))}
          </div>

          {/* Course Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {courses[activeTab as keyof typeof courses].map((course, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
                <div 
                  className="h-36 md:h-48 bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Children%20learning%20$%7BactiveTab%7D%20through%20interactive%20educational%20games%2C%20colorful%20classroom%20setting%20with%20digital%20learning%20tools%2C%20kids%20engaged%20and%20happy%2C%20modern%20educational%20technology%2C%20bright%20and%20cheerful%20atmosphere%2C%20professional%20educational%20photography&width=400&height=300&seq=${activeTab}-${index}&orientation=landscape')`
                  }}
                ></div>
                <div className="p-4 md:p-6">
                  <div className="flex justify-between items-start mb-3">
                    <h4 className="text-lg md:text-xl font-bold text-gray-900 flex-1 mr-2">{course.name}</h4>
                    <span className="bg-blue-100 text-blue-800 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium whitespace-nowrap">
                      {course.level}
                    </span>
                  </div>
                  <p className="text-gray-600 mb-4 text-sm md:text-base">{course.description}</p>

                  <div className="flex justify-between items-center">
                    {course.price ? (
                      <span className="text-lg md:text-2xl font-bold text-purple-600">{course.price}</span>
                    ) : (
                      <span className="text-sm md:text-lg text-gray-500">詳情請洽詢</span>
                    )}
                    <button 
                      onClick={() => document.querySelector('#trial-form')?.scrollIntoView({ behavior: 'smooth' })}
                      className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 md:px-6 py-2 rounded-full font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
                    >
                      立即試聽
                    </button>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">家長與學生的真實回饋</h3>
            <p className="text-lg md:text-xl text-gray-600">看看全台各地家庭的學習成果</p>
          </div>
          
          {/* 北部家長 */}
          <div className="mb-8 md:mb-12">
            <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center">北部地區</h4>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
              {testimonials.slice(0, 5).map((testimonial, index) => (
                <div key={index} className="bg-gradient-to-br from-blue-50 to-purple-50 p-4 md:p-6 rounded-xl">
                  <div className="flex mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-base md:text-lg"></i>
                    ))}
                  </div>
                  <p className="text-gray-700 mb-3 md:mb-4 italic text-xs md:text-sm">"{testimonial.content}"</p>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                    <p className="text-gray-600 text-xs md:text-sm">{testimonial.child}</p>
                    <p className="text-blue-600 text-xs md:text-sm">{testimonial.location}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 中部家長 */}
          <div className="mb-8 md:mb-12">
            <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center">中部地區</h4>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
              {testimonials.slice(5, 10).map((testimonial, index) => (
                <div key={index} className="bg-gradient-to-br from-green-50 to-blue-50 p-4 md:p-6 rounded-xl">
                  <div className="flex mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-base md:text-lg"></i>
                    ))}
                  </div>
                  <p className="text-gray-700 mb-3 md:mb-4 italic text-xs md:text-sm">"{testimonial.content}"</p>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                    <p className="text-gray-600 text-xs md:text-sm">{testimonial.child}</p>
                    <p className="text-green-600 text-xs md:text-sm">{testimonial.location}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 南部家長 */}
          <div>
            <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center">南部地區</h4>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
              {testimonials.slice(10, 15).map((testimonial, index) => (
                <div key={index} className="bg-gradient-to-br from-orange-50 to-yellow-50 p-4 md:p-6 rounded-xl">
                  <div className="flex mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-base md:text-lg"></i>
                    ))}
                  </div>
                  <p className="text-gray-700 mb-3 md:mb-4 italic text-xs md:text-sm">"{testimonial.content}"</p>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                    <p className="text-gray-600 text-xs md:text-sm">{testimonial.child}</p>
                    <p className="text-orange-600 text-xs md:text-sm">{testimonial.location}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Trial Form Section */}
      <section id="trial-form" className="py-12 md:py-20 bg-gradient-to-r from-blue-500 to-purple-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">免費試聽申請</h3>
            <p className="text-lg md:text-xl text-blue-100">立即體驗我們的遊戲化教學</p>
          </div>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-2xl">
            <form id="trial-application" data-readdy-form onSubmit={handleTrialSubmit} className="grid md:grid-cols-2 gap-4 md:gap-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">學生姓名 *</label>
                <input 
                  type="text" 
                  name="student_name" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入學生姓名"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">年級 *</label>
                <select 
                  name="grade" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇年級</option>
                  <option value="小一">小一</option>
                  <option value="小二">小二</option>
                  <option value="小三">小三</option>
                  <option value="小四">小四</option>
                  <option value="小五">小五</option>
                  <option value="小六">小六</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">家長姓名 *</label>
                <input 
                  type="text" 
                  name="parent_name" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入家長姓名"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">聯絡電話 *</label>
                <input 
                  type="tel" 
                  name="phone" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入聯絡電話"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">有興趣的課程 *</label>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-2 md:gap-3">
                  <label className="flex items-center">
                    <input type="checkbox" name="interested_courses" value="數學課程" className="mr-2" />
                    <span className="text-sm">數學課程</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" name="interested_courses" value="奧數課程" className="mr-2" />
                    <span className="text-sm">奧數課程</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" name="interested_courses" value="卓越杯課程" className="mr-2" />
                    <span className="text-sm">卓越杯課程</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" name="interested_courses" value="中檢課程" className="mr-2" />
                    <span className="text-sm">中檢課程</span>
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" name="interested_courses" value="英文課程" className="mr-2" />
                    <span className="text-sm">英文課程</span>
                  </label>
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">備註</label>
                <textarea 
                  name="notes" 
                  rows={4} 
                  maxLength={500}
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="有任何特殊需求或問題，歡迎告訴我們..."
                ></textarea>
              </div>
              <div className="md:col-span-2">
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                >
                  送出試聽申請
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Membership Form Section */}
      <section id="membership-form" className="py-12 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">年度會員購買</h3>
            <p className="text-lg md:text-xl text-gray-600">選擇最適合您的方案，享受一整年的學習樂趣</p>
          </div>
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6 md:p-8 shadow-xl">
            <form id="membership-purchase" data-readdy-form onSubmit={handleMembershipSubmit} className="grid md:grid-cols-2 gap-4 md:gap-6">
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">選擇方案 *</label>
                <select 
                  name="membership_plan" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇會員方案</option>
                  <option value="基礎方案 NT$6,000">基礎方案 NT$6,000 - 數學、國文、社會、英文、自然課程</option>
                  <option value="完整方案 NT$9,000">完整方案 NT$9,000 - 數學、奧數、卓越杯、超越杯、國文、中檢、英文、劍橋檢定、全民英檢、自然、社會</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">學生姓名 *</label>
                <input 
                  type="text" 
                  name="student_name" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入學生姓名"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">購買人姓名 *</label>
                <input 
                  type="text" 
                  name="buyer_name" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入購買人姓名"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">聯絡電話 *</label>
                <input 
                  type="tel" 
                  name="phone" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入聯絡電話"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">電子信箱 *</label>
                <input 
                  type="email" 
                  name="email" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入電子信箱"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">選擇年級一 *</label>
                <select 
                  name="grade_1" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇第一個年級</option>
                  <option value="小一">小一</option>
                  <option value="小二">小二</option>
                  <option value="小三">小三</option>
                  <option value="小四">小四</option>
                  <option value="小五">小五</option>
                  <option value="小六">小六</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">選擇年級二 *</label>
                <select 
                  name="grade_2" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇第二個年級</option>
                  <option value="小一">小一</option>
                  <option value="小二">小二</option>
                  <option value="小三">小三</option>
                  <option value="小四">小四</option>
                  <option value="小五">小五</option>
                  <option value="小六">小六</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">平板寄送地址 *</label>
                <textarea 
                  name="shipping_address" 
                  rows={3} 
                  required 
                  maxLength={500}
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請填寫完整的寄送地址，包含郵遞區號、縣市、區域、街道號碼..."
                ></textarea>
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">備註</label>
                <textarea 
                  name="notes" 
                  rows={3} 
                  maxLength={500}
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="有任何特殊需求請告訴我們..."
                ></textarea>
              </div>
              <div className="md:col-span-2">
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 md:py-4 rounded-lg font-bold text-base md:text-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  立即購買年度會員
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Tutoring Form Section */}
      <section id="tutoring-form" className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">線上家教預約</h3>
            <p className="text-lg md:text-xl text-gray-600">預約專業一對一家教課程，量身打造學習計畫</p>
          </div>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-xl">
            <form id="tutoring-booking" data-readdy-form onSubmit={handleTutoringSubmit} className="grid md:grid-cols-2 gap-4 md:gap-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">學生姓名 *</label>
                <input 
                  type="text" 
                  name="student_name" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入學生姓名"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">學生年級 *</label>
                <select 
                  name="student_grade" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇年級</option>
                  <option value="小一">小一</option>
                  <option value="小二">小二</option>
                  <option value="小三">小三</option>
                  <option value="小四">小四</option>
                  <option value="小五">小五</option>
                  <option value="小六">小六</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">家長姓名 *</label>
                <input 
                  type="text" 
                  name="parent_name" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入家長姓名"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">聯絡電話 *</label>
                <input 
                  type="tel" 
                  name="phone" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請輸入聯絡電話"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">選擇方案 *</label>
                <select 
                  name="course_plan" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇方案</option>
                  <option value="體驗方案 10堂 NT$7,000">體驗方案 10堂 NT$7,000</option>
                  <option value="進階方案 20堂 NT$12,000">進階方案 20堂 NT$12,000</option>
                  <option value="完整方案 30堂 NT$15,000">完整方案 30堂 NT$15,000</option>
                  <option value="月考總複習 NT$150/堂">月考總複習 NT$150/堂</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">主要科目 *</label>
                <select 
                  name="subject" 
                  required 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">請選擇主要科目</option>
                  <option value="數學">數學</option>
                  <option value="國文">國文</option>
                  <option value="英文">英文</option>
                  <option value="自然">自然</option>
                  <option value="社會">社會</option>
                  <option value="奧數">奧數</option>
                  <option value="全科">全科複習</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">希望上課時間</label>
                <input 
                  type="text" 
                  name="preferred_time" 
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="例：週一到週五 晚上7:00-8:00"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-gray-700 font-medium mb-2 text-sm md:text-base">學習目標與需求</label>
                <textarea 
                  name="learning_goals" 
                  rows={4} 
                  maxLength={500}
                  className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="請描述學生目前的學習狀況、需要加強的部分，或其他特殊需求..."
                ></textarea>
              </div>
              <div className="md:col-span-2">
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-purple-500 to-blue-600 text-white py-3 md:py-4 rounded-lg font-bold text-base md:text-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  預約家教課程
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">聯絡我們</h3>
              <p className="text-lg md:text-xl text-gray-600 mb-6 md:mb-8">
                有任何問題或需要更多資訊，歡迎隨時與我們聯繫
              </p>
              <div className="space-y-4 md:space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-blue-600 text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 text-sm md:text-base">客服專線</p>
                    <p className="text-gray-600 text-sm md:text-base">(04) 2243-6255</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-blue-600 text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 text-sm md:text-base">電子信箱</p>
                    <p className="text-gray-600 text-sm md:text-base">richqazstrong@yahoo.com.tw</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-blue-600 text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 text-sm md:text-base">地址</p>
                    <p className="text-gray-600 text-sm md:text-base">台中市北屯區北屯路388號2樓</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-blue-600 text-lg md:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 text-sm md:text-base">營業時間</p>
                    <p className="text-gray-600 text-sm md:text-base">週一至週六 09:00-21:00</p>
                    <p className="text-gray-600 text-sm md:text-base">週日公休</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg flex flex-col items-center justify-center">
              <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">加入我們的 LINE</h4>
              <p className="text-gray-600 mb-4 md:mb-6 text-center text-sm md:text-base">掃描 QR Code 加入官方 LINE<br />立即獲得課程諮詢與優惠資訊</p>
              <div className="bg-white p-4 rounded-xl shadow-md">
                <img 
                  src="https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/a7f5034a184c0574bf4415ff688caa0e.jpeg" 
                  alt="LINE QR Code" 
                  className="w-48 h-48 md:w-64 md:h-64 object-contain"
                />
              </div>
              <p className="text-xs md:text-sm text-gray-500 mt-4">使用 LINE 掃描加入好友</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 md:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-graduation-cap-line text-white text-base md:text-lg"></i>
                </div>
                <h5 className="text-lg md:text-xl font-bold" style={{fontFamily: '"Pacifico", serif'}}>CM探索教育科技</h5>
              </div>
              <p className="text-gray-400 text-sm md:text-base">
                專注於遊戲化教學的教育科技公司，讓學習變得更有趣更有效。
              </p>
            </div>
            <div>
              <h6 className="font-bold mb-4 text-sm md:text-base">課程分類</h6>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><a href="#courses" className="hover:text-white cursor-pointer">數學課程</a></li>
                <li><a href="#courses" className="hover:text-white cursor-pointer">奧數課程</a></li>
                <li><a href="#courses" className="hover:text-white cursor-pointer">卓越杯課程</a></li>
                <li><a href="#courses" className="hover:text-white cursor-pointer">中檢課程</a></li>
                <li><a href="#courses" className="hover:text-white cursor-pointer">英文課程</a></li>
              </ul>
            </div>
            <div>
              <h6 className="font-bold mb-4 text-sm md:text-base">服務項目</h6>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><a href="#trial-form" className="hover:text-white cursor-pointer">免費試聽</a></li>
                <li><a href="#contact" className="hover:text-white cursor-pointer">課程諮詢</a></li>
                <li><a href="#features" className="hover:text-white cursor-pointer">教學特色</a></li>
                <li><a href="#testimonials" className="hover:text-white cursor-pointer">學習成果</a></li>
              </ul>
            </div>
            <div>
              <h6 className="font-bold mb-4 text-sm md:text-base">聯絡資訊</h6>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>電話: (04) 2243-6255</li>
                <li>信箱: richqazstrong@yahoo.com.tw</li>
                <li>地址: 台中市北屯區北屯路388號2樓</li>
                <li>時間: 週一至週六 09:00-21:00</li>
              </ul>
            </div>
          </div>

          {/* Related Companies Section */}
          <div className="border-t border-gray-800 mt-6 md:mt-8 pt-6 md:pt-8">
            <h6 className="font-bold mb-6 md:mb-8 text-center text-lg md:text-xl">相關企業</h6>
            <div className="grid md:grid-cols-3 gap-6 md:gap-8">
              {/* CMAP運動健康品格寒假營隊 */}
              <div className="bg-gray-800 rounded-xl p-4 md:p-6 hover:bg-gray-700 transition-all group">
                <div className="flex flex-col items-center text-center">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-run-line text-white text-xl md:text-2xl"></i>
                  </div>
                  <h5 className="font-bold text-white mb-2 text-base md:text-lg">CMAP運動健康品格寒假營隊</h5>
                  <p className="text-gray-400 text-xs md:text-sm mb-4">專業運動健康與品格教育營隊</p>
                  <a 
                    href="https://www.cmapedu.com" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center text-green-400 hover:text-green-300 transition-colors cursor-pointer text-xs md:text-sm font-medium"
                  >
                    了解更多
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>
              </div>

              {/* 威斯理美語 */}
              <div className="bg-gray-800 rounded-xl p-4 md:p-6 hover:bg-gray-700 transition-all group">
                <div className="flex flex-col items-center text-center">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-translate-2 text-white text-xl md:text-2xl"></i>
                  </div>
                  <h5 className="font-bold text-white mb-2 text-base md:text-lg">威斯理美語</h5>
                  <p className="text-gray-400 text-xs md:text-sm mb-4">專業英語教育機構</p>
                  <a 
                    href="https://www.yeswecanedu.com/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center text-blue-400 hover:text-blue-300 transition-colors cursor-pointer text-xs md:text-sm font-medium"
                  >
                    了解更多
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>
              </div>

              {/* 中華原住民暨家庭兒童預期協會 */}
              <div className="bg-gray-800 rounded-xl p-4 md:p-6 hover:bg-gray-700 transition-all group">
                <div className="flex flex-col items-center text-center">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-heart-line text-white text-xl md:text-2xl"></i>
                  </div>
                  <h5 className="font-bold text-white mb-2 text-base md:text-lg">中華原住民暨家庭兒童預期協會</h5>
                  <p className="text-gray-400 text-xs md:text-sm mb-4">關懷原住民家庭與兒童發展</p>
                  <a 
                    href="https://www.taiwanchild.com" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center text-orange-400 hover:text-orange-300 transition-colors cursor-pointer text-xs md:text-sm font-medium"
                  >
                    了解更多
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-6 md:mt-8 pt-6 md:pt-8 text-center text-gray-400 text-sm">
            <p>&copy; 2024 CM探索教育科技股份有限公司. 版權所有. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;